const locale = "en-US";
const translations = {
	timeFormat: "h:mm a",
	dateFormat: "MM/DD/YYYY",
	dateTimeFormat: "MM/DD/YYYY h:mm a",
	"serviceReports.headline": "Service reports",
	"serviceReports.sublineMachine": "View and download the service reports for your machine.",
	"serviceReports.technicianName": "Name of service engineer",
	"serviceReports.machineNameAndNumber": "Machine & machine no.",
	"serviceReports.startDate": "From",
	"serviceReports.endDate": "To",
	"serviceReports.creationDate": "Creation date",
	"serviceReports.openReport": "Open service report (PDF)",
	"serviceReports.filter": "Filter",
	"serviceReports.missionNumber": "Mission number",
	"serviceReports.assignmentType": "Service report type",
	"serviceReports.reportTypes.IA": "De-Installation / Relocation report",
	"serviceReports.reportTypes.AC": "Application consulting report",
	"serviceReports.reportTypes.IV": "Installation preparation report",
	"serviceReports.reportTypes.BA": "Appraisal report",
	"serviceReports.reportTypes.UV": "Safety inspection report",
	"serviceReports.reportTypes.IG": "Installation of pre-owned machine report",
	"serviceReports.reportTypes.UB": "Quality measure report",
	"serviceReports.reportTypes.PN": "Production assistance report",
	"serviceReports.reportTypes.NR": "Retrofit report",
	"serviceReports.reportTypes.IB": "Installation/start-up report",
	"serviceReports.reportTypes.II": "Installation integration report",
	"serviceReports.reportTypes.IC": "Internal repair report",
	"serviceReports.reportTypes.MB": "Trade fair service report",
	"serviceReports.reportTypes.HW": "Resource report",
	"serviceReports.reportTypes.TT": "Technician training report",
	"serviceReports.reportTypes.SK": "Customer training report",
	"serviceReports.reportTypes.RP": "Repair report",
	"serviceReports.reportTypes.RW": "Repair and maintenance report",
	"serviceReports.reportTypes.WA": "Maintenance report",
	"serviceReports.reportTypesPlural.IA": "De-Installation / Relocation reports",
	"serviceReports.reportTypesPlural.AC": "Application consulting reports",
	"serviceReports.reportTypesPlural.IV": "Installation preparation reports",
	"serviceReports.reportTypesPlural.BA": "Appraisal reports",
	"serviceReports.reportTypesPlural.UV": "Safety inspection reports",
	"serviceReports.reportTypesPlural.IG": "Installation of pre-owned machine reports",
	"serviceReports.reportTypesPlural.UB": "Quality measure reports",
	"serviceReports.reportTypesPlural.PN": "Production assistance reports",
	"serviceReports.reportTypesPlural.NR": "Retrofit reports",
	"serviceReports.reportTypesPlural.IB": "Installation/start-up reports",
	"serviceReports.reportTypesPlural.II": "Installation integration reports",
	"serviceReports.reportTypesPlural.IC": "Internal repair reports",
	"serviceReports.reportTypesPlural.MB": "Trade fair service reports",
	"serviceReports.reportTypesPlural.HW": "Resource reports",
	"serviceReports.reportTypesPlural.TT": "Technician training reports",
	"serviceReports.reportTypesPlural.SK": "Customer training reports",
	"serviceReports.reportTypesPlural.RP": "Repair reports",
	"serviceReports.reportTypesPlural.RW": "Repair and maintenance reports",
	"serviceReports.reportTypesPlural.WA": "Maintenance reports",
	"serviceReports.loadMore": "Load more",
	"serviceReports.loadError": "Error when loading data",
	"serviceReports.noReportsFound": "There are currently no service reports.",
	"serviceReports.noReportsAvailable": "There are currently no service reports.",
	missingAuthorization: "Authorization missing",
	"headline.createCase": "Creating a new service case",
	"headline.caseDetails": "Case details",
	"headline.contactData": "Contact data",
	"field.reason.label": "Case reason",
	"field.machine.label": "Machine & machine no.",
	"field.softwareProblemClassification.label": "Problem classification",
	"field.softwareInstallationProblem.label": "Installation problem",
	"field.softwareLicenseIssue.label": "License problem",
	"field.softwareType.label": "Software type",
	"field.softwareModule.label": "Software module",
	"field.errorNumber.label": "Error numbers",
	"field.errorNumber.explanation": "e.g. 0000FC00, 1.10.58102409 or 6000",
	"field.errorNumber.addAnotherNumber": "Add other error numbers",
	"field.errorNumber.errorMessage": "Invalid error number",
	"field.message.label": "Message",
	"field.message.placeholder": "Please describe your concern/problem with as many concrete details as possible and as necessary (without greeting). Thank you.",
	"field.fileUpload.label": "Attachments",
	"field.fileUpload.info": "Permitted file formats: IMG, JPG, PNG, PDF, HTML, TruTops files etc. (max. 16 MB) and MP4 video files (max. 50 MB)",
	"field.salutation.label": "Form of address",
	"field.salutation.male": "Mr.",
	"field.salutation.female": "Ms.",
	"field.firstName.label": "First name",
	"field.lastName.label": "Surname",
	"field.email.label": "Email",
	"field.phone.label": "Telephone number",
	"button.submit": "Send",
	"button.cancel": "Cancel",
	"button.back": "Back",
	"button.next": "Next",
	"button.close": "Close",
	"button.ok": "Ok",
	"auth.error": "An unexpected error occurred.",
	"select.placeholder": "Please select...",
	"validation.requiredField": "This is a compulsory field",
	"validation.invalidEmail": "Please enter a valid e-mail address",
	"validation.maxAllowedCharacters": "Maximum number of characters permitted: {{number}}",
	"validation.requiredFieldsExplanation": "Mandatory fields are marked with *.",
	"validation.invalidPhoneNumber": "Please enter a valid telephone number.",
	"softwareProblemClassification.standstill": "Downtime",
	"softwareProblemClassification.fault": "Malfunction",
	"softwareProblemClassification.slightImpairment": "Slight impairment",
	"softwareProblemClassification.generalInquiry": "General inquiry",
	"serviceCase.proactiveCaseClosure.title": "Feedback & case closure request",
	"serviceCase.proactiveCaseClosure.instructions": "In order to request a case closure and help us improve our predictive service, we kindly ask for your feedback.",
	"serviceCase.proactiveCaseClosure.question.submit": "Send",
	"serviceCase.proactiveCaseClosure.dialogTitle": "Case closure requested. Thank you for your feedback.",
	"serviceCase.proactiveCaseClosure.dialog.buttonOk": "Ok",
	"serviceCase.proactiveCaseClosure.question.anomaly": "Was the reported anomaly present on your machine?",
	"serviceCase.proactiveCaseClosure.question.technicalGuideLinked": "Was a Technical Guide provided?",
	"serviceCase.proactiveCaseClosure.question.technicalGuideHelpful": "Were you able to solve the problem yourself with the help of the Technical Guide(s)?",
	"serviceCase.proactiveCaseClosure.question.pauseRequest": "Do you want to pause notifications for this type of anomaly?",
	"serviceCase.proactiveCaseClosure.question.pauseRequestDuration": "How long do you want to pause notifications for this type of anomaly?",
	"serviceCase.proactiveCaseClosure.question.comment": "Please explain why you want to pause notifications for this type of anomaly:",
	"serviceCase.proactiveCaseClosure.question.commentPlaceholder": "Comment required to request case closure and send feedback",
	"serviceCase.proactiveCaseClosure.answers.yes": "Yes",
	"serviceCase.proactiveCaseClosure.answers.no": "No",
	"serviceCase.proactiveCaseClosure.answers.sevenDays": "7 days",
	"serviceCase.proactiveCaseClosure.answers.fourteenDays": "14 days",
	"serviceCase.proactiveCaseClosure.answers.thirtyDays": "30 days",
	"serviceCase.proactiveCaseClosure.answers.ninetyDays": "90 days",
	"sisConnector.success.headline": "Service case was created successfully.",
	"sisConnector.success.orderNumberRequired.title": "Note:",
	"sisConnector.success.orderNumberRequired.text": "Please add a purchase order number for case billing and further services on the case detail page.",
	"sisConnector.success.technicalGuide.title": "A Technical Guide is available for this error number(s).",
	"sisConnector.success.technicalGuide.text": "Based on the error number(s) entered, one or more Technical Guide(s) have been found. In approx. 50% of cases, you will be able to solve the problem yourself. This function is only available with a corresponding service agreement.",
	"sisConnector.success.outsideOfServiceHours": "Please remember that cases created outside of our service times will not be processed.",
	"sisConnector.success.serviceTimes.MonFri": "Our service times are: Monday to Friday",
	"sisConnector.success.serviceTimes.Sat": "and Saturday",
	"sisConnector.success.withTechnicalServiceHotline": "If you require help immediately, please call TRUMPF's Technical Service ({{hotline}}) for support.",
	"sisConnector.success.withoutTechnicalServiceHotline": "If you require help immediately, please call TRUMPF‘s Technical Service for support.",
	"sisConnector.success.caseId": "Case number",
	"sisConnector.failed.headline": "The service case could not be created.",
	"sisConnector.failed.unknownError": "Please try again or contact your support team."
};
var enUS = {
	locale: locale,
	translations: translations
};

export { enUS as default, locale, translations };
//# sourceMappingURL=en-US-ms8H1udj.js.map

//# sourceMappingURL=en-US-ms8H1udj.js.map